<template>
  <a-modal
    :width="1300"
    :footer="null"
    title="Əməliyyatlar"
    :visible="modalVisible"
    @cancel="modalVisible = false"
  >
    <a-row>
      <a-col :span="15">
        <a-table
          :columns="columns"
          :data-source="data"
          :row-key="(user) => user.id"
        >
          <template slot="user" slot-scope="record">
            {{ record.user.firstName }} {{ record.user.lastName }}
            {{ record.user.fatherName }} ({{ record.step }})</template
          >
          <template slot="dateStr" slot-scope="dateStr">
            {{ dateStr }}
          </template>
          <template slot="operation" slot-scope="record">
            ({{ record.operation }})
            <p v-if="record.text&&record.text.length > 50">
              {{ record.text.slice(0, 50) }} 
            
            </p>
            <p v-if="record.text&&record.text.length <50">
              {{record.text}}
            </p>
          </template>
          <template slot="action" slot-scope="record">
              <a-tooltip v-if="record.id !== dataId" :title="record.text">
                      <span
              
              class="custom__span"
              style="
                background: rgb(221 219 219);
                padding: 3px 10px;
                border-radius: 3px;
                cursor: pointer;
              "
              @click="getDetail(record.newProblemDetails, record.id)"
              >Qeyd</span>
              </a-tooltip>
     
            
            <span
              v-else
              class="custom__span"
              style="
                background: #26c08a;
                padding: 3px 10px;
                border-radius: 3px;
                cursor: pointer;
              "
              @click="getDetail(record.newProblemDetails, record.id)"
              >...
            </span>
          </template>
        </a-table>
      </a-col>

      <a-col :span="9">
        <a-row v-if="detail">
          <div>
      <!--       <div v-if="detail.text" class="detail__history">
              <a-row>
                <a-col :span="8">
                  <p>Qeyd</p>
                </a-col>
                <a-col :span="16">
                  <p>{{ detail.text }}</p>
                </a-col>
              </a-row>
            </div> -->

            <div v-if="detail.reasonNote" class="detail__history">
              <a-row>
                <a-col :span="8">
                  <p>Səbəb</p>
                </a-col>
                <a-col :span="16">
                  <p>{{ detail.reasonNote }}</p>
                </a-col>
              </a-row>
            </div>

            <div v-if="detail.address" class="detail__history">
              <a-row>
                <a-col :span="8">
                  <p>Ünvan</p>
                </a-col>
                <a-col :span="16">
                  <p>{{ detail.address }}</p>
                </a-col>
              </a-row>
            </div>

            <div v-if="detail.executive" class="detail__history">
              <a-row>
                <a-col :span="8">
                  <p>Yerli icra hakimiyyəti orqanı</p>
                </a-col>
                <a-col :span="16">
                  <p>{{ detail.executive.name }}</p>
                </a-col>
              </a-row>
            </div>

            <div v-if="detail.text" class="detail__history">
              <a-row>
                <a-col :span="8">
                  <p>Müraciətin qısa məzmunu</p>
                </a-col>
                <a-col :span="16">
                  <p>{{ detail.text }}</p>
                </a-col>
              </a-row>
            </div>

            <div v-if="detail.priorityLevel" class="detail__history">
              <a-row>
                <a-col :span="8">
                  <p>Əhəmiyyət dərəcəsi</p>
                </a-col>
                <a-col :span="16">
                  <p>
                    {{
                      priorityLevels.find(
                        (item) => item.name === detail.priorityLevel
                      ).title
                    }}
                  </p>
                </a-col>
              </a-row>
            </div>
            <div
              v-if="detail.categories && detail.categories.length > 0"
              class="detail__history"
            >
              <a-row>
                <a-col :span="8">
                  <p>Kateqoriyalar</p>
                </a-col>
                <a-col :span="16">
                  <span v-for="(arr, index) in detail.categories" :key="index"
                    >{{ arr.name }},</span
                  >detail
                </a-col>
              </a-row>
            </div>

            <div v-if="detail.coverMedia" class="detail__history">
              <a-row>
                <a-col :span="8">
                  <p>Örtük şəkili</p>
                </a-col>
                <a-col :span="16">
                  <img width="120" :src="prefix + detail.coverMedia" alt="" />
                </a-col>
              </a-row>
            </div>
          </div>
        </a-row>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
import mixin from "@/mixins/index";
export default {
  props: { visible: Boolean, request: Object },
  mixins: [mixin],
  methods: {
    getDetail(argument, id) {
      this.dataId = id;
      this.detail = argument;
    },
    getReqHistoryModal() {
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "requests/story/" +
          this.request.id,
      }).then((response) => {
        this.data = response.data.data;
      });
    },
  },

  data() {
    return {
      columns: [
        {
          title: "İstifadəçi",
          width: "27%",
          scopedSlots: { customRender: "user" },
        },
        {
          title: "Əməliyyat",

          width: "27%",
          scopedSlots: { customRender: "operation" },
        },
        {
          title: "Tarix",
          dataIndex: "dateStr",
          width: "27%",
          scopedSlots: { customRender: "dateStr" },
        },
        { title: "Qeyd", width: "19%", scopedSlots: { customRender: "action" } },
      ],
      dataId: null,
      data: null,
      detail: null,
      modalVisible: false,
      prefix: URL[process.env.NODE_ENV].file_url,
    };
  },
  created() {
    this.modalVisible = this.visible;
  },
  watch: {
    visible: function (newValue, oldValue) {
      this.modalVisible = this.visible;
      if (!oldValue && newValue && this.request) {
        this.getReqHistoryModal();
      }
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.$emit("afterClose");
      }
    },
  },
};
</script>

<style>
.detail__history:nth-child(even) {
  background-color: #f2f2f2;
  margin-top: 5px;
}

@media only screen and (max-width: 900px) {
  .ant-col-15,
  .ant-col-9 {
    width: 100%;
  }
  .custom__span {
    padding: 3px 1px !important;
  }
  .ant-modal-content {
    overflow-x: scroll;
  }
  .ant-modal-body,
  .ant-modal-header {
    width: 160%;
  }
  .ant-modal-close {
    right: -55%;
  }
}
</style>
